import { callAPI, HTTPMethod } from "./API";
import { LedgerAccounts, LedgerAccount, LedgerAccountsQueryParams, LedgerAccountRequest, LedgerAccountStatusRequest } from "../model/LedgerAccount";

const basePath = (tenantId: string) => `/tenants/${tenantId}/ledger-accounts`;

export async function listLedgerAccounts(tenantId: string, pageSize: number, offset: number, params: LedgerAccountsQueryParams): Promise<LedgerAccounts> {
    let query = {
            number: params.number || '',
            name: params.name || '',
            company: params.company || '',
            pageSize: pageSize.toString(),
            offset: offset.toString()
        } as Record<string, string>;
        
    if(params.status) {
        query = { ...query, status: params.status };
    }

    return await callAPI(`/tenants/${tenantId}/ledger-accounts`, {
      method: HTTPMethod.GET,
      query: query
    });
}

export async function createLedgerAccount(tenantId: string, request: LedgerAccountRequest): Promise<LedgerAccount> {
    const payload = mapRequestToPayload(request);
    
    return await callAPI(`${basePath(tenantId)}`, {
        method: HTTPMethod.POST,
        body: payload
    });
}

export async function getLedgerAccount(tenantId: string, id: string): Promise<LedgerAccount> {
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.GET
    });
}

export async function updateLedgerAccount(tenantId: string, id: string, request: LedgerAccountRequest): Promise<LedgerAccount> {
    const payload = mapRequestToPayload(request);
    
    return await callAPI(`${basePath(tenantId)}/${id}`, {
        method: HTTPMethod.PUT,
        body: payload
    });
}

export async function changeStatusLedgerAccount(tenantId: string, id: string, request: LedgerAccountStatusRequest): Promise<LedgerAccount> {
    return await callAPI(`${basePath(tenantId)}/${id}/change-status`, {
      method: HTTPMethod.PUT,
      body: request
    });
}

function mapRequestToPayload(request: LedgerAccountRequest) {
    return {
        number: request.number,
        name: request.name,
        external_id: request.externalId,
        applies_to_all_companies: request.appliesToAllCompanies,
        company_ids: request.companyIds || []
    };
}